(() => {
  const carouselSelector = '.jdgm-cards-carousel';
  const cardSelector = '.jdgm-card';
  const productCache = new Map();
  const processingCards = new WeakSet();

  const productRequest = (productLink) => {
    const productUrl = new URL(productLink.href, window.location.origin);
    const handleMatch = productUrl.pathname.match(/\/products\/([^/]+)\/?$/);

    if (!handleMatch) {
      return Promise.reject(new Error('Product handle unavailable'));
    }

    const handle = decodeURIComponent(handleMatch[1]);

    if (!productCache.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      const requestUrl = `${root}products/${encodeURIComponent(handle)}.js`;
      const request = fetch(requestUrl, {
        headers: { Accept: 'application/json' },
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`Product request failed: ${response.status}`);
        }

        return response.json();
      });

      productCache.set(handle, request);
    }

    return productCache.get(handle);
  };

  const sizedImageUrl = (source) => {
    const imageUrl = new URL(source, window.location.origin);
    imageUrl.searchParams.set('width', '160');
    return imageUrl.toString();
  };

  const handleProductLinkClick = (event) => {
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(event.currentTarget.href);
  };

  const buildProductLink = (product, sourceLink) => {
    const link = document.createElement('a');
    link.className = 'siyou-review-product';
    link.href = sourceLink.href;
    link.addEventListener('click', handleProductLinkClick);

    const image = document.createElement('img');
    image.className = 'siyou-review-product__image';
    image.src = sizedImageUrl(product.featured_image);
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.width = 52;
    image.height = 52;

    const name = document.createElement('span');
    name.className = 'siyou-review-product__name';
    name.textContent = product.title || sourceLink.textContent.trim();

    const arrow = document.createElement('span');
    arrow.className = 'siyou-review-product__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';

    link.append(image, name, arrow);
    return link;
  };

  const enhanceCard = async (card) => {
    if (card.querySelector('.siyou-review-product')) {
      card.dataset.siyouProductEnhanced = 'true';
      return;
    }

    if (
      card.dataset.siyouProductEnhanced === 'true' ||
      card.dataset.siyouProductEnhanced === 'failed' ||
      processingCards.has(card)
    ) {
      return;
    }

    const sourceLink = card.querySelector('.jdgm-product-name a[href*="/products/"]');
    const ratingSection = card.querySelector('.jdgm-rating-section');

    if (!sourceLink || !ratingSection) return;

    processingCards.add(card);
    card.dataset.siyouProductEnhanced = 'pending';

    try {
      const product = await productRequest(sourceLink);

      if (!product.featured_image || !card.isConnected) {
        throw new Error('Product image unavailable');
      }

      ratingSection.append(buildProductLink(product, sourceLink));
      card.dataset.siyouProductEnhanced = 'true';
    } catch (_error) {
      card.dataset.siyouProductEnhanced = 'failed';
    } finally {
      processingCards.delete(card);
    }
  };

  const enhanceCarousel = (carousel) => {
    carousel.querySelectorAll(cardSelector).forEach(enhanceCard);
  };

  const scan = (scope) => {
    if (!(scope instanceof Element || scope instanceof Document)) return;

    if (scope instanceof Element) {
      const containingCarousel = scope.closest(carouselSelector);

      if (containingCarousel) {
        enhanceCarousel(containingCarousel);
      }
    }

    scope.querySelectorAll(carouselSelector).forEach(enhanceCarousel);
  };

  const start = () => {
    scan(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => scan(node));
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
